import { render, staticRenderFns } from "./HappeningNowBlock.vue?vue&type=template&id=7d6f91ce"
import script from "./HappeningNowBlock.vue?vue&type=script&lang=js"
export * from "./HappeningNowBlock.vue?vue&type=script&lang=js"
import style0 from "./HappeningNowBlock.vue?vue&type=style&index=0&id=7d6f91ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports